import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuditService } from '../../services/audit.service';
import { AuditActivator } from '../../models/auditActivator';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { NgForm } from '@angular/forms';
import { AppConfigService } from '../../config/app-config.service';
import { debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
declare var require: any;

@Component({
    selector: 'app-activatorAuditLogs',
    templateUrl: './activatorAuditLogs.component.html',
    styleUrls: ['activatorAuditLogs.component.css']
})
export class ActivatorAuditLogsComponent implements OnInit {

    dateFrom: string;
    dateSince: string;
    amountDaysActivatorAuditLogs: number;
    hasResult: boolean = false;

    constructor(private translate: TranslateService, private service: AuditService, private toastr: ToastrService, private authService: AuthService,
        private spinner: NgxSpinnerService, private appSettings: AppConfigService, private auditRoute: ActivatedRoute) {

        this.amountDaysActivatorAuditLogs = this.auditRoute.snapshot.params.amountDaysActivatorAuditLogs;
    }

    AuditActivatorList: AuditActivator[] = [];

    selectedAuditActivatorId: number;

    //grid
    dataSourceAuditActivator = new MatTableDataSource<AuditActivator>();
    displayedColumnsAudit: string[] = ['id', 'source', 'action', 'detail', 'result', 'usr', 'datetime'];
    @ViewChild('Paginator', { static: true }) Paginator: MatPaginator;
    @ViewChild('Sort', { static: true }) Sort: MatSort;
    isLoading = true;
    selection = new SelectionModel<AuditActivator>(true, []);

    @ViewChild('fileInput') fileInput: ElementRef;

    filterValues: any = {};

    selectedRowIndex: any;
    readonly = false;
    objAuditActivator = new AuditActivator();

    public seedsVersion: string;

    ngOnInit(): void {
        this.setDefaultValues();
        this.onSubmit();
    }

    setDefaultValues() {

        //utiliza fecha de AmountDaysActivatorAuditLogs días atrás
        this.dateFrom = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24 * this.amountDaysActivatorAuditLogs).toISOString().substring(0, 11) + '00:00';
        this.dateSince = new Date().toISOString().substring(0, 11) + '23:59';
    }

    onSubmit() {
        this.showGrids("hide");

        if (!this.fieldsValidation())
            this.toastr.warning(this.translate.instant("COUNTRY_AUDIT_LOGS.MSG_MANDATORY_FIELDS"));
        else {
            this.fillGrid();
        }
    }

    showGrids(grid) {
        let elemGrid: HTMLElement = document.getElementById('grid');

        switch (grid) {
            case "activ":
                elemGrid.setAttribute("style", "display:block;");
                break;
            default:
                elemGrid.setAttribute("style", "display:none;");
                break;
        }
    }

    fieldsValidation(): boolean {
        if ((this.dateFrom == null || this.dateFrom == "") ||
            (this.dateSince == null || this.dateSince == ""))
            return false;
        else
            return true;
    }

    fillGrid() {
        this.spinner.show();
        this.isLoading = true;

        this.service.getAuditActivatorList(this.dateFrom, this.dateSince, this.authService.getLoginFromToken()).pipe(debounceTime(800)).subscribe(
                res => {
                    this.isLoading = false;

                    this.AuditActivatorList = res;

                    if (this.AuditActivatorList.length == 0) {
                        this.emptySearch();
                        this.hasResult = false;
                    }
                    else {
                        this.showGrids("activ");
                        this.hasResult = true;
                    }

                    this.dataSourceAuditActivator = new MatTableDataSource<AuditActivator>();
                    this.dataSourceAuditActivator.data = res as [];
                    this.dataSourceAuditActivator.sort = this.Sort;
                    this.dataSourceAuditActivator.paginator = this.Paginator;
                    this.dataSourceAuditActivator.paginator._intl.itemsPerPageLabel = this.translate.instant("REG.ITEMS_PER_PAGE");
                    this.spinner.hide();
                },
                err => {
                    this.selection = new SelectionModel<AuditActivator>(true, []);
                    this.spinner.hide();
                });
    }

    emptySearch() {
        this.toastr.warning(this.translate.instant("COUNTRY_AUDIT_LOGS.EMPTY_DATA"));
        this.showGrids("hide");
    }

    selectAuditActivatorRow(id) {
        this.selectedRowIndex = id;
        this.selectedAuditActivatorId = Number(id);
    }

    resetForm(form: NgForm) {
        this.readonly = false;
        this.setDefaultValues();
        this.showGrids("hide");
    }

    openDialog(): void {
        let event = new MouseEvent('click', { bubbles: false });
        this.fileInput.nativeElement.dispatchEvent(event);
    }

    ExportAudit() {
        this.spinner.show();

        this.service.ExportAudit(this.authService.getLoginFromToken(), this.dateFrom, this.dateSince)
            .subscribe((result: any) => {

                if (result.type != 'text/plain') {
                    var blob = new Blob([result]);
                    let saveAs = require('file-saver');
                    let date = new Date();

                    let file = "Audit-" + date.toISOString() + ".xlsx";
                    saveAs(blob, file);
                    this.spinner.hide()
                    this.toastr.success("", this.translate.instant("ADMIN.DOWNLOAD") + " " + this.translate.instant("COM.SUCCESSFUL"))
                }
                else {
                    this.spinner.hide()
                    this.toastr.error("", this.translate.instant("ADMIN.NO_DATA"));
                }
            },
                err => {

                    this.spinner.hide();

                }
            )
    }
}
